import { render, staticRenderFns } from "./DocumentDropZone.vue?vue&type=template&id=65183f7c&scoped=true"
import script from "./DocumentDropZone.vue?vue&type=script&lang=ts"
export * from "./DocumentDropZone.vue?vue&type=script&lang=ts"
import style0 from "./DocumentDropZone.vue?vue&type=style&index=0&id=65183f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65183f7c",
  null
  
)

export default component.exports